module.exports = __webpack_public_path__ + "img/featured-image.915df5bc.jpg";